module.exports = __webpack_public_path__ + "assets/img/index-partner16.0f358df4.jpg";